// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function() {
    // Select the div with the specific classes
    var targetDiv = document.querySelector(".osr-ib-app-multiple-booking-info-flex.osr-padding-lr-20.osr-card-border-bottom");

    // Check if the target div exists
    if (targetDiv) {
        // Create a new paragraph element to hold the text
        var infoText = document.createElement("p");
        // Set the text content of the new paragraph
        infoText.textContent = "Note:  If you need to reschedule your class, please contact us at info@breasydxb.com";

        // Append the paragraph with the text to the target div
        targetDiv.appendChild(infoText);
    }
});
